import { formToJSON } from "axios";
import { useState, useRef , useContext} from "react";
import { Card, ListGroup } from "react-bootstrap"
import DataTable from "react-data-table-component";
import {Modal, Row, Col,Button, Form} from 'react-bootstrap';
import Icon from "../Icon/Icon";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";

// export const tableColumns = [
//   {
//     name: "id",
//     selector: (row) => row.id,
//     sortable: false,
//     hide : "lg",
//     omit : true, 

//   },
//   {
//       name: "Service",
//       selector: (row) => row.pro.proName,
//       sortable: true,      
//     },
//   {
//     name: "Rate (£/Hour)",
//     selector: (row) => '£' + row.payRate.toFixed(2),
//     sortable: true,    
//   },  
//   {
//     name: "",
//     Button:true,              
//     cell: (row) => (                 
//         <>
//         <Icon name="edit-fill"></Icon>Edit
//         </>           
//     ),
//     sortable: false,      
// },
  
// ];

const AgentPayRates = ({RateData, MainCustomerID}) => {  

  const api = useApiClient();
  const {SiteConfig} = useContext(AppContext);
  const [currData, setCurrData] = useState();
  const [previewModal, setPreviewModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const modalForm = useRef(null);
  const modalFormAdd = useRef(null);
  const [DatatoUse, setData] = useState(RateData);
  const [error, setError] = useState(null);
  const [serviceList, setserviceList] = useState(null);
  const[restrictedMode, setRestrictedMode] = useState((SiteConfig.CURRENT_USER_ROLE=="user"?true:false));


// 🔽 Define columns inside the component
  const tableColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: false,
      hide: "lg",
      omit: true,
    },
    {
      name: "Service",
      selector: (row) => row.pro.proName,
      sortable: true,
    },
    {
      name: "Rate (£/Hour)",
      selector: (row) => "£" + row.payRate.toFixed(2),
      sortable: true,
    },
    // Conditionally show the Edit column
    ...(!restrictedMode
      ? [
          {
            name: "",
            button: true,
            cell: (row) => (
              <>
                <Icon name="edit-fill" />
                Edit
              </>
            ),
            sortable: false,
          },
        ]
      : []),
  ];


  function detailSelect(obj){

    //console.log(obj);
    setCurrData(obj);
    setPreviewModal(true)

    // const currentData = {...selectedData,
    // proId:obj.proId,
    // proName:obj.proName,
    // proDesc:obj.proDesc,
    // status:obj.status,
    // date_created: obj.date_created,
    // date_modified: obj.date_modified
    // }

    // setSelectedData(currentData)
    // setPreviewModal(true)

    }

    function closePreviewModal(){
      setPreviewModal(false);
      } 

      function closeAddModal(){
        setAddModal(false);
        }    

      function openAddModel(){

        //console.log(MainCustomerID);

          //if(serviceList != null) {
            
          const baseURL2 = "HMCareData/servicelist/"  
      
          api.get(baseURL2)        
          .then((Response)=>{
            setserviceList(Response.data);

            //console.log(serviceList);
            
            //setData(RateData);

            setAddModal(true);
          }).catch(error => {
              setError(error);     
              //console.log({error})
          });
                        
         // }

        

          
          }   

      function handleFormSubmit(event){

        event.preventDefault();
        let customerHourlyRate = modalForm.current.querySelector('#customerHourlyRate').value;
       
       
        
        const frmFormData = new FormData();
        frmFormData.append("ProId", currData.proId) 
        frmFormData.append("AgentId", currData.agentId)                
        frmFormData.append("Id", currData.id) 
        frmFormData.append("PayRate", customerHourlyRate) 
        
        const sURL = "HMCareData/customer/modifyagentservicerates/";
        
        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;            
            updateState(updatedDataObj)
            
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });

        setPreviewModal(false);

    }  
    
    
    function handleFormSubmitAdd(event){

      //console.log(RateData)
      //return null

      event.preventDefault();
      let customerHourlyRate = modalFormAdd.current.querySelector('#customerHourlyRate').value;
      let ProID = modalFormAdd.current.querySelector('#ProID').value;
                
      const frmFormData = new FormData();
      frmFormData.append("ProId", ProID)       
      frmFormData.append("AgentId", MainCustomerID)       
      frmFormData.append("PayRate", customerHourlyRate) 
      
      const sURL = "HMCareData/customer/addagentservicerates/";
    
      api.post(sURL,frmFormData)
      .then((Response)=>{

          let updatedDataObj = Response.data; 
                   
          let tempArr = [...DatatoUse];
          tempArr.push(updatedDataObj);

          setData(tempArr)

      }).catch(error => {
          setError(error);     
          //console.log({error})
      });

      setAddModal(false);

  }  


    const updateState = (updatedData) => {

      const newState = DatatoUse.map(obj => {
          // 👇️ if id equals 2, update country property
          if (obj.proId === updatedData.proId) {
          return {...obj, 
              //proName: updatedData.proName,
              payRate: updatedData.payRate
              //status:updatedData.status            
          };
          }
  
          // 👇️ otherwise return the object as is
          return obj;
      });
      
      setData(newState);
      
      };


  return (     
    
    <>
    
    {!restrictedMode &&
      <Button variant="outline-primary" action="add" onClick={openAddModel}>
        <Icon name="plus"></Icon><span>Add Service</span>
        </Button>
    }

    <DataTable tableClassName="data-table-head-light table-responsive" 
      data={DatatoUse} 
      columns={tableColumns} 
      striped={true} 
      highlightOnHover={true}  
      filterFieldName={"Service"} 
      {...(!restrictedMode && {
    onRowClicked: (row, event) => {
      detailSelect(row);
    },
  })}    
      />   

{currData && 
      <Modal show={previewModal} onHide={closePreviewModal}>
      <Modal.Header closeButton>
        <Modal.Title className="event-title" as="h4">Modify Service Rates</Modal.Title>  
      </Modal.Header>
      
      <Form ref={modalForm} onSubmit={handleFormSubmit}>
      <Modal.Body>
        <div>
          <Row className="g-3">       
              <Col xs="12">
                  <Form.Group>
                      <h6 className="overline-title">Rate (£/Hour)</h6>
                      <div className="form-control-wrap">
                          <Form.Control id="customerHourlyRate" type="text" defaultValue={currData.payRate} placeholder="Value" />
                      </div>
                  </Form.Group>
              </Col>                    
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>          
          <Button variant="primary" type="submit">Update</Button>
      </Modal.Footer>
      </Form>
      </Modal>}

      <Modal show={AddModal} onHide={closeAddModal}>
      <Modal.Header closeButton>
        <Modal.Title className="event-title" as="h4">Modify Service Rates</Modal.Title>  
      </Modal.Header>
      
      <Form ref={modalFormAdd} onSubmit={handleFormSubmitAdd}>
      <Modal.Body>
        <div>
          <Row className="g-3">  
             {serviceList && 
             <Col xs="12">
                  <Form.Group>
                      <Form.Label htmlFor="eventTitle">Service</Form.Label>
                      <Form.Select id="ProID" defaultValue={modalForm.ProId}>   
                          {serviceList.map(service =>(
                            <option value={service.id}>{service.value}</option>  
                          ))}                                                                                                                               
                      </Form.Select>
                  </Form.Group>
              </Col>   
              }  
              <Col xs="4">
                  <Form.Group>
                      <h6 className="overline-title">Rate (£/Hour)</h6>
                      <div className="form-control-wrap">
                          <Form.Control id="customerHourlyRate" type="text" defaultValue={DatatoUse.payRate} placeholder="Eg, 60.00" />
                      </div>
                  </Form.Group>
              </Col>                    
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>          
          <Button variant="primary" type="submit">Update</Button>
      </Modal.Footer>
      </Form>
      </Modal>


      </>

  )
}

export default AgentPayRates